module.exports = __webpack_public_path__ + "img/pic12.1d6e3683.png";